var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5943 28.8136C22.5509 28.8136 29.0011 22.3634 29.0011 14.4068C29.0011 6.45014 22.5509 0 14.5943 0C6.63764 0 0.1875 6.45014 0.1875 14.4068C0.1875 22.3634 6.63764 28.8136 14.5943 28.8136Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9933 15.602C12.9501 15.5513 12.9166 15.5087 12.878 15.4695C12.1515 14.6904 11.4245 13.9111 10.6968 13.1315C10.549 12.9519 10.3492 12.8222 10.1249 12.7604C9.90052 12.6985 9.66255 12.7073 9.44346 12.7858C9.26728 12.8526 9.11075 12.9627 8.98829 13.1059C8.86583 13.2492 8.78136 13.4209 8.74268 13.6053C8.70399 13.7897 8.71232 13.9809 8.76691 14.1613C8.8215 14.3416 8.92059 14.5053 9.05505 14.6373C10.3159 15.968 11.5613 17.3135 12.8129 18.6528C12.8383 18.6799 12.8705 18.7018 12.8999 18.7306L13.0486 18.5934C13.6426 18.0418 14.2373 17.4903 14.8327 16.939C16.5861 15.3016 18.3384 13.6631 20.0895 12.0234C20.203 11.9256 20.2954 11.8058 20.3614 11.6713C20.4273 11.5368 20.4653 11.3904 20.4731 11.2408C20.4808 11.0912 20.4582 10.9416 20.4066 10.8009C20.355 10.6603 20.2755 10.5316 20.1728 10.4226C20.0701 10.3135 19.9464 10.2264 19.8091 10.1665C19.6718 10.1065 19.5238 10.075 19.3741 10.0738C19.2243 10.0726 19.0758 10.1018 18.9376 10.1595C18.7994 10.2173 18.6743 10.3024 18.5699 10.4098C17.065 11.8109 15.5608 13.2132 14.0571 14.6166L12.9933 15.602Z",
    fill: "#161615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm-icon.d3c29bfe46b1191763d3af79c8b0cf0f.svg";
export { ForwardRef as ReactComponent };